import { render } from "./UserListItem.vue?vue&type=template&id=0c560679"
import script from "./UserListItem.vue?vue&type=script&lang=ts"
export * from "./UserListItem.vue?vue&type=script&lang=ts"
script.render = render

export default script